// Components==============
import { SoundGroupExerciseContext } from 'components/Exercises/SoundGroupExercise/SoundGroupExercise';
import { SoundsExerciseContext } from 'components/Exercises/SoundsExercise/SoundsExercise';
import { SoundType } from 'components/UI/LetterBlock/LetterBlock';
import React, { useContext } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import './DroppableTile.module.scss';
// =========================

export default function DroppableTile({
    isDroppable,
    children,
    setTileBarState,
    id,
    index,
    tileBarState,
    done,
}: {
    isDroppable: boolean;
    children: React.ReactNode;
    setTileBarState: React.Dispatch<React.SetStateAction<SoundType[]>>;
    id: string;
    index: number;
    tileBarState: SoundType[];
    done?: boolean;
}) {
    function deleteTile(ind: number) {
        setTileBarState((prev) =>
            prev.map((e, i) => {
                if (i === ind) return '';
                return e;
            })
        );
    }

    const dragStartId1 = useContext(SoundsExerciseContext)?.dragStartId;
    const dragStartId2 = useContext(SoundGroupExerciseContext)?.dragStartId;
    const dragStartId = dragStartId1 || dragStartId2;

    if (isDroppable)
        return (
            <Droppable key={id} droppableId={id}>
                {(DropProvided) => (
                    <div
                        ref={DropProvided.innerRef}
                        {...DropProvided.droppableProps}
                        onClick={() => deleteTile(index)}
                        styleName="drop-tile"
                    >
                        {children}
                        {dragStartId !== id && (
                            <div
                                styleName="drop-placeholder"
                                style={{
                                    display:
                                        tileBarState[index] !== ''
                                            ? 'none'
                                            : 'block',
                                }}
                            >
                                {DropProvided.placeholder}
                            </div>
                        )}
                    </div>
                )}
            </Droppable>
        );
    return (
        <div
            styleName="drop-tile"
            style={{ opacity: done && tileBarState[index] === '' ? 0.25 : 1 }}
        >
            {children}
        </div>
    );
}
